import ownerDocument from './owner-document';

var getDocument = function (element) { return ownerDocument(element).documentElement; };

export default getDocument;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@progress/kendo-popup-common/dist/es/document.js
// module id = 215
// module chunks = 0